// const BaseUrl = "https://doctorconsultation.py.logicspice.com/";
// const BaseUrl = "http://127.0.0.1:8000/"; 
const BaseUrl = "https://doctor-appointment-software.logicspice.com/"; 

export default BaseUrl;